export type MapLightPreset = 'dawn' | 'day' | 'dusk' | 'night';

// A little unlit material color keeps APS models readable in low light while
// most of their shading still comes from the basemap. Night stays below dusk.
export const CUSTOM_MODEL_EMISSIVE_STRENGTH: Record<MapLightPreset, number> = {
  dawn: 0.08,
  day: 0,
  dusk: 0.22,
  night: 0.18,
};
